import React from 'react';
import _ from 'lodash';

import {
  useRestockItemModalQuery,
  useTriageTier1ReturnAuthorizationMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  triageWorkflowId: string;
  formState: types.IFormState;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useRestockItemModalQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const workflow = _.find(
        tuple.data?.tier1ReturnAuthorization?.group.store.triageWorkflows,
        wf => wf.type.name === 'restock'
      );
      const data: IData = {
        triageWorkflowId: workflow?.id ?? '',
        formState: {
          binNumber: workflow?.netSuiteBinInternalId ?? '',
          item: {
            id: tuple.data?.tier1ReturnAuthorization?.itemReceipt?.item.id ?? '',
            displayName: tuple.data?.tier1ReturnAuthorization?.itemReceipt?.item.name ?? ''
          },
          technicianComment: ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useTriageTier1ReturnAuthorization(returnAuthorizationId: string) {
  const [fnMutate, tuple] = useTriageTier1ReturnAuthorizationMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (triageWorkflowId: string, formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            returnAuthorizationId,
            triageWorkflowId,
            technicianComment: formState.technicianComment
          }
        }
      });
    },
    [
      fnMutate,
      returnAuthorizationId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
